import * as parse from 'modules/parse'

export function digital(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['How can technology\nimprove how we learn?']
        }
      ],
      [
        {
          type: 'p',
          content: 'How will digital tools change how we learn? How can we re-imagine and experiment with education beyond summer camps?'
        },
        {
          type: 'p',
          content: 'We believe technology can empower and facilitate learning — from improving how a student\'s progress is tracked and understood to personalizing learning materials based on a student\'s evolving needs.'
        },
        {
          type: 'p',
          content: 'We believe new tools can make learning more interactive than ever before as digital screens break free from the limits of pen & paper to become infinite, context-aware canvases for self-expression.'
        }
      ],
      [
        {
          type: 'p',
          content: 'We believe the Internet can bring students, teachers and makers closer together to create applications that interact as part of a life-long and consistent learning experience.'
        },
        {
          type: 'p',
          content: 'To achieve this vision, we\'re starting small. For students, we\'re building an app that teaches basic literacy. For teachers, we\'re building an app that tracks a student\'s progress in doing homework.'
        },
        {
          type: 'h5',
          content: ['To learn more, sign up to our newsletter!'],
          linkURL: 'https://gakkoproject.us4.list-manage.com/subscribe/post?u=fa4319fecd8b40e74b6a3ee7b&id=477d0e625d',
          outbound: true
        }
      ]
    ]
  }
}

export function jobs(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Join us.']
        },
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Digital Learning Product Manager']
        }
      ],
      [
        {
          type: 'h5',
          // style: 'sectra-light',
          content: ['Job description']
        },
        {
          type: 'p',
          content: 'Gakko Digital Learning is looking for an enthusiastic and talented Product Manager to take our first application to market. We are rethinking the digital experience for students of all ages, starting with our youngest audience (3 to 5 year olds). We’ve combined our exciting new SDK with award-winning artistic talent to create an experience that’s unique and bold.'
        },
        {
          type: 'p',
          content: 'Our PM must be very goal oriented and impact driven, be passionate about producing moving learning experiences for students of all ages, and be a kid at heart. This is a product role with an active participation in strategy, research, feature design, as well as project management. We are looking for someone who has experience launching both Apple and Android mobile apps (managing the submission process, assets required, coordinating with PR efforts), navigating customer (qualitative) and sales (quantitative) feedback, with proactive fervor to create and harness opportunities to push our app to the top. First and foremost, our PM needs to be a stellar communicator to ensure the team works efficiently and harmoniously. Collaborating with engineers and designers, drafting spec docs, and wire-framing ideas are some of the many tasks required by the PM.'
        }
      ],
      [
        {
          type: 'p',
          style: ['marginTop'],
          content: 'This is an opportunity to join a small but mighty team and help shape the future products coming down the pipeline. This is a full-time position in NYC.'
        },
        {
          type: 'h5',
          // style: 'sectra-light',
          content: ['Requirements']
        },
        {
          type: 'p',
          content: '—2+ year experience as a PM\n—Experience launching apps to the App Store and/or Google Play Store\n—Experience with user testing and qualitative feedback\n—Passion for metrics and a data-driven approach to success\n—Team-orientated and good communicator (both written and verbal)\n—Ability to visualize concepts in wire-frames for designers and engineers'
        },
        {
          type: 'h5',
          content: ['Ready to revolutionize the way we interact with educational content? Send a cover letter and resume to hiring@gakkoproject.com. We look forward to hearing from you!'],
          linkURL: 'mailto:hiring@gakkoproject.com',
          outbound: true
        }
      ]
    ]
  }
}




// WEBPACK FOOTER //
// ./src/modules/digital.js